import { DeletableEdge } from './DeletableEdge'

export const edgeTypes = {
  deletable: DeletableEdge,
}
